import { WhitelabelSettingReadModel } from "../../../@api";

/**
 * Gets the effective value from a whitelabel setting.
 * Returns customValue if it's not empty, otherwise returns defaultValue.
 */
export const getWhitelabelValue = (setting: WhitelabelSettingReadModel | undefined): string | undefined => {
  if (!setting) {
    return undefined;
  }
  return setting.customValue || setting.defaultValue;
};
